import { Box, Container, Flex, Icon, Image, Text } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { FaTiktok } from "react-icons/fa";
import {
  RiFacebookBoxFill,
  RiInstagramFill,
  RiYoutubeFill,
} from "react-icons/ri";

const Footer = ({ t }) => {
  return (
    <Box bg="main_1" color="white" w="100%" overflow="hidden" p={4}>
      <Container
        maxWidth={"container.xl"}
        bg="#e4e8eb78"
        borderRadius="20px"
        p={4}
      >
        <Flex
          justifyContent={"space-between"}
          flexDirection={{ base: "column", md: "row" }}
          alignItems="center"
        >
          <Flex flexDirection={"column"} w={{ base: "100%", md: "45%" }}>
            <Image src={require("../../../assets/logo.png")} w="200px" />{" "}
          </Flex>
          <Flex direction="column">
            <Text fontWeight="500" color="white">
              {t("components.footer.desc")}{" "}
            </Text>

            <Flex w={{ base: "100%", md: "15%" }} gap={5} mt={2} align="start">
              <a
                href="https://www.facebook.com/share/1CD9CFi47G/?mibextid=wwXIfr"
                target="_blank"
                rel="noreferrer"
              >
                <Icon as={RiFacebookBoxFill} fontSize="45px" color="white" />
              </a>
              <a
                href="https://youtube.com/@b-study.online?si=vGI5PB6ukQLnOitE"
                target="_blank"
                rel="noreferrer"
              >
                <Icon as={RiYoutubeFill} fontSize="45px" color="white" />
              </a>
              <a
                href="https://www.instagram.com/bstudy.eg?igsh=MTNjM3I2ZWliazN5eA=="
                target="_blank"
                rel="noreferrer"
              >
                <Icon as={RiInstagramFill} fontSize="45px" color="white" />
              </a>
              <a
                href="https://www.tiktok.com/@bstudy.online?_t=ZS-8zsoDtXMUS7&_r=1"
                target="_blank"
                rel="noreferrer"
              >
                <Icon as={FaTiktok} fontSize="45px" color="white" />
              </a>
            </Flex>
          </Flex>
        </Flex>
      </Container>
      <Text textAlign="center" marginTop={2}>
        Powered by Asquera
      </Text>
    </Box>
  );
};

export default withTranslation()(Footer);
